export * from "./fetch";
import { useAPI } from "../../utils/use-api";
import { Endpoint } from "../common/endpoints";
import { useMutation } from "../../utils/use-mutation";
import { passwordResetTokenCreate, passwordResetTokenUse } from "./fetch";
export const usePasswordResetTokenCreate = (params) => {
    return useMutation(passwordResetTokenCreate, params);
};
export const usePasswordResetTokenUse = (passwordResetTokenId, params) => {
    return useMutation((body, queryParams, headers) => {
        return passwordResetTokenUse(passwordResetTokenId, body, queryParams, headers);
    }, params);
};
export const usePasswordResetTokenSelf = (passwordResetTokenId, queryParams, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.PasswordResetTokenSelf,
        endpointParams: { passwordResetTokenId },
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
